import { render } from "./Buttons.vue?vue&type=template&id=b7d17fc6"
const script = {}

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__